let optionDetails = optionDetailsDTO;

(function () {

    (function addElementsBbcodeLink() {

        document.querySelectorAll(".card-text").forEach(
            function (edito) {
                const {oeventCategory, oeventAction} = edito.dataset;

                edito.querySelectorAll("a").forEach(
                    function (link) {
                        link.className = '';
                        link.classList.add("ob1-link-arrow", "ob1-link");
                        const hrefAttr = link.getAttribute("href");
                        link.dataset.oeventCategory = "fiche_option";
                        link.dataset.oeventAction = toBroadbandTmsFormat(link.innerText);
                        if (hrefAttr.startsWith("#")) {
                            link.target = "_self";
                            link.dataset.bsToggle = "modal";
                            link.dataset.oeventLabel = hrefAttr.slice(1);
                        } else {
                            link.target = "_blank";
                            link.dataset.oeventLabel = hrefAttr;
                        }
                    }
                );
            }
        );
    }());

    new Vue({
        el: "#detailPage",
        data: {
            optionDetails: optionDetails,
            hasAnyVariationBeenSelected: false,
            isError: false,
            isFormEmpty: true,
            selectedVariation: {}
        },
        computed: {
            showSelectedVariationIneligibilityMessageAlerte: function(){
                return !this.optionDetails.anyVariationIsSubscribable
                    && this.selectedVariation.selectBtn
                    && this.selectedVariation.selectBtn.ineligibilityMessageAlerte;
            },
            showSelectedVariationSelectBtn: function(){
                return !this.showSelectedVariationIneligibilityMessageAlerte;
            }
        },
        watch: {
            selectedVariation: function () {
                this.isError = false;
                this.isFormEmpty = false;
                this.hasAnyVariationBeenSelected = true;
                Vue.nextTick(() => {
                    reportWindowSize();
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#header-banner-priceblock").offset().top
                    }, 500);
                });
            }
        },
        created() {
            let index = parseInt(new URLSearchParams(window.location.search).get("order"));
            if (index && this.optionDetails.variations.length  >= index) {
                this.selectedVariation = this.optionDetails.variations[index - 1];
            } else {
                this.selectedVariation.shortLabel = this.optionDetails.shortLabel;
                this.selectedVariation.shortDescription = this.optionDetails.shortDescription;
                this.selectedVariation.selectBtn = this.optionDetails.selectBtn;
                this.selectedVariation.tag = this.optionDetails.tag;
                this.selectedVariation.withTag = this.optionDetails.tag != null;
                this.selectedVariation.tariffDTO = this.optionDetails.tariffDTO;
                this.selectedVariation.identification = this.optionDetails.identification;
                this.selectedVariation.cartAccessUrl = this.optionDetails.cartAccessUrl;
            }
        },
        methods: {
            selectVariation: function (variation) {
                this.selectedVariation = variation;
            },
            clickSelectVariation: function (event) {
                if (this.optionDetails.hasVariations
                    && !this.hasAnyVariationBeenSelected) {
                    this.isError = true;
                    Vue.nextTick(() => {
                        reportWindowSize();
                    });
                } else {
                    window.location.href = event.target.getAttribute('href');
                }
            }
        }
    });
})();

function reportWindowSize() {
    let priceBlockContainerHeight = document.getElementById("header-banner-priceblock").offsetHeight;
    let bannerContainerHeight = document.getElementById("header-banner").offsetHeight;

    let headerBanner = document.getElementById("header-banner");
    let blocVariations = document.getElementById("bloc-variations");
    let detailBody = document.getElementById("detail-body");
    let keyPoints = document.getElementById("key-points");

    let priceBlockContainerHeightPaddingTop = 15;
    let keyPointsMarginTop = 60;
    let blocVariationsPaddingTop = 30;

    if ($(window).width() < 736) {
        // toujours sticky en mobile
        headerBanner.classList.add("header-banner--sticky");

        if (typeof (blocVariations) != "undefined" && blocVariations != null) {
            keyPoints.style.marginTop = keyPointsMarginTop + "px";
            if (priceBlockContainerHeight + 170 > bannerContainerHeight) {
                blocVariations.style.paddingTop = (priceBlockContainerHeight + 170) - bannerContainerHeight
                    + blocVariationsPaddingTop + "px";
            } else {
                blocVariations.style.paddingTop = blocVariationsPaddingTop + "px";
            }
        } else {
            if (priceBlockContainerHeight + 170 > bannerContainerHeight) {
                detailBody.style.marginTop = (priceBlockContainerHeight + 170) - bannerContainerHeight
                    + keyPointsMarginTop + "px";
            } else {
                detailBody.style.marginTop = keyPointsMarginTop + "px";
            }
        }

    } else {
        priceBlockContainerHeight = priceBlockContainerHeight + priceBlockContainerHeightPaddingTop;
        // sticky uniquement si le bloc est supérieur à l"image en mode desktop
        if (typeof (blocVariations) != "undefined" && blocVariations != null) {
            keyPoints.style.marginTop = keyPointsMarginTop + "px";
            if (priceBlockContainerHeight > bannerContainerHeight) {
                headerBanner.classList.add("header-banner--sticky");
                blocVariations.style.paddingTop = priceBlockContainerHeight - bannerContainerHeight
                    + blocVariationsPaddingTop + "px";
            } else {
                headerBanner.classList.remove("header-banner--sticky");
                blocVariations.style.paddingTop = blocVariationsPaddingTop + "px";
            }
        } else {
            if (priceBlockContainerHeight > bannerContainerHeight) {
                headerBanner.classList.add("header-banner--sticky");
                detailBody.style.marginTop = priceBlockContainerHeight - bannerContainerHeight
                    + keyPointsMarginTop + "px";
            } else {
                headerBanner.classList.remove("header-banner--sticky");
                detailBody.style.marginTop = keyPointsMarginTop + "px";
            }
        }
    }

}

function toBroadbandTmsFormat(string) {
    return string.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/’/g, "_")
        .split(" ")
        .join("_")
        .toLowerCase();
}
document.getElementsByClassName("header-banner-image")[0].onload = reportWindowSize;

window.onresize = reportWindowSize;

reportWindowSize();
